var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseCircle = function SvgCloseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 .625C5.728.625.625 5.728.625 12S5.728 23.375 12 23.375 23.375 18.272 23.375 12 18.272.625 12 .625Zm0 1.75A9.612 9.612 0 0 1 21.625 12 9.612 9.612 0 0 1 12 21.625 9.612 9.612 0 0 1 2.375 12 9.612 9.612 0 0 1 12 2.375ZM8.693 7.433l-1.26 1.26L10.742 12l-3.309 3.307 1.26 1.26L12 13.257l3.307 3.308 1.26-1.258L13.257 12l3.308-3.307-1.258-1.26L12 10.742 8.693 7.434v-.002Z"
  })));
};
export default SvgCloseCircle;